import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "@/components/shared";

export default function CompanyProfile() {
  const { profile, user } = useAuth();
  if (!profile) return null;
  const rows = [
    ["Legal name", profile.legal_name], ["Trade name", profile.trade_name], ["GSTIN", profile.gstin],
    ["PAN", profile.pan], ["CIN/LLPIN", profile.cin || "—"], ["Company email", profile.company_email],
    ["Contact person", `${profile.contact_person} (${profile.designation})`], ["Mobile", profile.mobile],
    ["Address", `${profile.address}, ${profile.state} - ${profile.pincode}`],
    ["Website", profile.website || "—"], ["Categories", (profile.categories || []).join(", ") || "—"],
    ["Bank account", profile.bank?.account_number ? `${profile.bank.account_number} · ${profile.bank.ifsc || ""}` : "Not provided"],
  ];
  return (
    <div className="mx-auto max-w-2xl space-y-5">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl font-semibold text-forest">Company Profile</h1>
        <StatusBadge status={profile.verification_status} />
      </div>
      <div className="rounded-xl border border-border bg-card p-6">
        <dl className="divide-y divide-border">
          {rows.map(([k, v]) => (
            <div key={k} className="grid grid-cols-3 gap-4 py-3 text-sm"><dt className="text-ink/50">{k}</dt><dd className="col-span-2 text-ink">{v}</dd></div>
          ))}
        </dl>
      </div>
      {profile.verification_note?.reason && (
        <div className="rounded-xl border border-border bg-card p-4 text-sm"><span className="overline text-olive">Reviewer note</span><p className="mt-1 text-ink/70">{profile.verification_note.reason}</p></div>
      )}
    </div>
  );
}
